import React, { useState } from 'react';

import { Spinner } from '@telus-uds/components-web';
import PropTypes from 'prop-types';

import PermissionItem from './components/permissionItem';

import {
  BlockBody,
  BlockItemContainer,
  BlockItemHead,
  BlockTitle,
  EditOverlay
} from '../../css';

const BlockItem = ({ data, orderPermissions, onUpdatePermission }) => {
  const { name } = data;

  const [isUpdating, setUpdating] = useState(false);

  return (
    <BlockItemContainer>
      <BlockItemHead>
        <BlockTitle>{name}</BlockTitle>
      </BlockItemHead>
      <BlockBody>
        {data.permissions.map(permission => (
          <PermissionItem
            permission={permission}
            orderPermissions={orderPermissions}
            onUpdatePermission={onUpdatePermission}
            setUpdating={setUpdating}
          />
        ))}
      </BlockBody>
      {isUpdating && (
        <EditOverlay>
          <Spinner label="Updating..." show={isUpdating}></Spinner>
        </EditOverlay>
      )}
    </BlockItemContainer>
  );
};

BlockItem.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string,
    permissions: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        description: PropTypes.string
      })
    )
  }).isRequired,
  orderPermissions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      isEnabled: PropTypes.bool,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      createdAt: PropTypes.string,
      updatedAt: PropTypes.string
    })
  ).isRequired,
  onUpdatePermission: PropTypes.func.isRequired
};

export default BlockItem;
